import { Row } from '@tanstack/react-table';

import { CellContents } from './columns/cell-contents';
import { GroupRow } from './rows/group';
import { useTable } from './table-state-provider';

const rowClasses = 'group/tablerow [&:has(:checked)]:bg-gray-200 [&:has(:checked)]:is-selected';

const getRowVirtualizationEnabled = (enableRowVirtualization: { minRows: number } | boolean, numRows: number) => {
  if (typeof enableRowVirtualization === 'boolean') {
    return enableRowVirtualization;
  }
  return enableRowVirtualization?.minRows <= numRows;
};

const Body = () => {
  const { table, rowVirtualizer, enableRowVirtualization } = useTable();
  const { rows } = table?.getRowModel() ?? { rows: [] };
  const virtualRows = rowVirtualizer?.getVirtualItems() ?? [];
  const totalSize = rowVirtualizer?.getTotalSize() ?? 0;

  const paddingTop = virtualRows.length > 0 ? virtualRows?.[0]?.start || 0 : 0;
  const paddingBottom = virtualRows.length > 0 ? totalSize - (virtualRows?.[virtualRows.length - 1]?.end || 0) : 0;

  const isRowVirtualized = getRowVirtualizationEnabled(enableRowVirtualization, totalSize);
  const rowsToRender = isRowVirtualized ? virtualRows : rows;

  return (
    <tbody>
      {isRowVirtualized && paddingTop > 0 && (
        <tr>
          <td style={{ height: `${paddingTop}px` }} />
        </tr>
      )}
      {rowsToRender.map((rowToRender) => {
        const row = isRowVirtualized ? rows[rowToRender.index] : (rowToRender as Row<unknown>);
        const cells = row?.getVisibleCells() || [];

        return row?.getIsGrouped() ? (
          <GroupRow row={row} table={table} />
        ) : (
          <tr key={row?.id} className={`body-tr ${rowClasses}`}>
            {cells?.map((cell) => {
              return <CellContents key={`cell_${cell?.id}`} cell={cell} />;
            })}
          </tr>
        );
      })}
      {isRowVirtualized && paddingBottom > 0 && (
        <tr>
          <td style={{ height: `${paddingBottom}px` }} />
        </tr>
      )}
    </tbody>
  );
};

export default Body;
